import React, { useState } from "react";
import useTranslation from "../../../../hooks/useTranslation";
import AddNewCompanyModal from "../../../Shared/Modals/AddNewCompanyModal/AddNewCompanyModal";
import SettingsListingTable from "../../Shared/SettingsListingTable/SettingsListingTable";
import "../CompanySettingsPage.scss";

const CompaniesList = ({
  tableHeaders,
  tableData,
  isUserSuperAdmin,
  fetchCompanies,
}) => {
  const { t } = useTranslation("settingsPage");

  return (
    <div className="company-settings-page__list">
      <div className="company-settings-page__list__header">
        <h2>{t("companies")}</h2>
        <AddNewCompanyModal />
      </div>
      <div className="company-settings-page__list__content">
        <SettingsListingTable
          tableHeaders={tableHeaders}
          tableData={tableData || []}
          tableType="company"
          fetchCompanies={fetchCompanies}
          isUserSuperAdmin={isUserSuperAdmin}
        />
      </div>
    </div>
  );
};

export default CompaniesList;
